export const STORAGE_SAVE_LIST_ITEM = 'STORAGE_SAVE_LIST_ITEM';

export const PRODUCT_LIST_PAGE_SHOP_LOCAL_SHOWN =
  'PRODUCT_LIST_PAGE_SHOP_LOCAL_SHOWN';
